import request from '@/utils/request'
import qs from 'qs'

export function getComboOutput(id, params, fieldId) {
  return request({
    url: `/combospecs/${id}/output?param=${JSON.stringify(params || {})}&FieldId=${fieldId || 0}`,
    method: 'get'
  })
}

export function getSerialOutput(id, params) {
  return request({
    url: `/serialspecs/${id}/output`,
    method: 'get',
    params
  })
}

export function getListViewInfo(id) {
  return request({
    url: `/listspecs/${id}`,
    method: 'get'
  })
}

export function getListSpecsOutput(params, data) {
  params = JSON.parse(JSON.stringify(params))
  params.param = JSON.stringify(params.param)
  return request({
    url: `/listspecs/${params.id}/output`,
    method: 'post',
    params,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    },
    data
  })
}

// 获取列表规范的分类树，支持按层级进行动态获取, 层级在level中指定
export function getDataSpecListClassification(id, params, data) {
  params = JSON.parse(JSON.stringify(params))
  params.param = JSON.stringify(params.param)
  return request({
    url: `/listspecs/${id}/classification`,
    method: 'post',
    params,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    },
    data
  })
}

export function getDataSpecInfo(templateId) {
  return request({
    url: `/templates/${templateId}/dataspec`,
    method: 'get'
  })
}

export function getCascaderSpecsOutput(params) {
  return request({
    url: `/treespecs/${params.id}/output?id=${params.id}&fieldId=${params.fieldId}&param=${JSON.stringify(params.param)}`,
    method: 'get'
  })
}

export function getSelectorSpecsInfo(id, fieldId) {
  return request({
    url: `/checkspecs/${id}?id=${id}&fieldId=${fieldId || 0}`,
    method: 'get'
  })
}

export function getSelectorSpecsOutput(id, fieldId) {
  return request({
    url: `/checkspecs/${id}/output?id=${id}&fieldId=${fieldId || 0}`,
    method: 'get'
  })
}

export function getSystemVariables() {
  return request({
    url: `/systemvariables`,
    method: 'get'
  })
}
